import type { UnionTypeLibelle } from '../../techniques'

export const TypeContact = ['ContactPilote', 'ContactAef', 'CoordonneesRegion', 'CoordonneesWeb'] as const

export type TypeContact = (typeof TypeContact)[number]

export const TypeContactLibelle: UnionTypeLibelle<TypeContact> = {
  ContactPilote: 'CEF',
  ContactAef: 'AEF',
  CoordonneesRegion: 'Coordonnées régionales',
  CoordonneesWeb: 'Coordonnées nationales',
} as const
